import styled from 'styled-components';

export const DisclosureText = styled.p`
  font-family: 'Karla', sans-serif;
  font-size: 12px;
  line-height: 2;
  display: block;
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
`;
